Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TikTok", {
  enumerable: true,
  get: function get() {
    return _tiktok.TikTok;
  }
});
var _tiktok = require("./tiktok");